export default __webpack_public_path__ + "static/media/hn.f978cc1c.svg";